<template>
  <div>
    <div class="admin-following-section">

      <!--      <div v-if="getFollowingStudents.length !== 0">-->
      <!--          <b-list-group>-->
      <!--            <b-list-group-item  v-for="(student,i) in getFollowingStudents"-->
      <!--                                :key="i">{{ student.name }}</b-list-group-item>-->
      <!--          </b-list-group>-->
      <!--      </div>-->
<div class="top-bar">
  <h4 class="">Students</h4>
  <div class="search-wrapper">
    <!--<b-input-group >-->
      <!--<template v-slot:prepend>-->
        <!--<b-input-group-text>-->
          <!--<font-awesome-icon icon="search"></font-awesome-icon>-->
        <!--</b-input-group-text>-->
      <!--</template>-->
      <!--<b-form-input placeholder="Search"></b-form-input>-->
    <!--</b-input-group>-->
  </div>
  <div class="sort-wrapper">
    <b-dropdown variant="link" no-caret id="dropdown-1" class="m-md-2">
      <template v-slot:button-content>
        <font-awesome-icon icon="sort-amount-down"></font-awesome-icon>
      </template>
      <b-dropdown-item  v-for="(item,i) in sortOption" :key="i" @click="sortList(item)">{{ item.label }}</b-dropdown-item>
    </b-dropdown>
  </div>
</div>
      <div>
        <b-table hover :fields="fields" :items="items" :sort-by="sortBy" :sort-desc="sortDesc">
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(name)="data">
            <div class="name-wrapper">
            <img src="https://placeimg.com/31/31/people" alt="">
            <span>{{ data.value }}</span>
            </div>
          </template>

        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "following-students",
  data() {
    return {
        fields: [
            { key: "index", label: "No" },
            { key: "name", label: "Student Name" },
        ],
        sortBy:'',
        sortDesc:"",
        sortOption:[
            { label: "Name Ascending",
                key: "name",
                sortDesc: false,
            },
            {
                label:"Name Descending",
                key: "name",
                sortDesc: true
            }
        ],
      items: []
    };
  },
  computed: {
    ...mapGetters("user", ["getFollowingStudents"])
  },
    methods:{
        sortList(item){
            this.sortBy = item.key;
            this.sortDesc = item.sortDesc
        }
    },
    mounted(){
      this.getFollowingStudents.forEach( student => {
          this.items.push(student)
      })
    }
};
</script>

<style scoped></style>
